import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import BookingCTA from "@/components/home/BookingCTA";
import { GALLERY } from "@/data/content";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <PageShell testId="gallery-page">
      <PageHero
        overline="The Gallery"
        title={["Frames Of", "The Valley"]}
        subtitle="A visual wander through cottages, mist, food and fire."
        image={GALLERY[0]}
      />

      <section className="bg-ivory py-14 md:py-20">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="columns-2 gap-4 md:columns-3 lg:columns-4 [&>*]:mb-4">
            {GALLERY.map((src, i) => (
              <motion.button
                key={i}
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(src)}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: (i % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="group block w-full overflow-hidden rounded-2xl"
              >
                <img src={src} alt={`Vruksha Valley gallery ${i + 1}`} loading="lazy" className="w-full transition-transform duration-700 group-hover:scale-105" />
              </motion.button>
            ))}
          </div>
        </div>
      </section>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[80] flex items-center justify-center bg-charcoal/95 p-5"
          >
            <button data-testid="lightbox-close" onClick={() => setActive(null)} aria-label="Close" className="absolute right-5 top-5 text-ivory/80 hover:text-ivory">
              <X className="h-8 w-8" />
            </button>
            <motion.img
              src={active}
              alt="Vruksha Valley"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="max-h-[85vh] max-w-full rounded-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <BookingCTA />
    </PageShell>
  );
}
